import {useAsyncRetry} from 'react-use';

import {getAllApps, getApp, getAppRoles} from '@/api/apps';

export function useApps() {
    return useAsyncRetry(() => {
        return getAllApps();
    }, []);
}

export function useApp(appId) {
    return useAsyncRetry(() => {
        return getApp(appId);
    }, [appId]);
}

export function useAppRoles(appId) {
    return useAsyncRetry(() => {
        return getAppRoles(appId);
    }, [appId]);
}
